export enum SadtTypeEnum{
    Outros = 0,
}